import styled from "@emotion/styled";
import theme from "theme";
import background from "@assets/images/background.webp";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  margin: -8px;
  font-family: Roboto;
`;

const LogoLoginImage = styled.div`
  flex: 1;
  position: relative;
  background-image: url(${background});
  background-color: rgba(0, 0, 0, 0.2);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1000;

  @media (max-width: 600px) {
    display: none;
  }
`;

const ForgetForm = styled.div`
  background-color: ${theme.colors.white};
  padding: 10px;
  border-radius: 25px;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    width: 60%;
  }

  @media (min-width: 1025px) {
    width: 50%;
  }
`;

const Form = styled.form`
  width: 100%;
`;

const Label = styled.label`
  color: ${theme.colors.black};
  font-family: Roboto;
  font-size: 15px;
  font-weight: 400;
`;

const TransparentInput = styled.input`
  width: 93%;
  padding: 2px 2px 2px 20px;
  margin-bottom: 10px;
  background-color: transparent;
  color: ${theme.colors.black};
  font-size: 16px;
  font-family: Roboto;
  outline: none;
  border: 1px solid grey;
  border-radius: 5px;
  height: 30px;

  &::placeholder {
    opacity: 0.5;
    color: ${theme.colors.black};
    font-size: 12px;
    font-family: Roboto;
  }
`;

const Button = styled.button`
  width: 100%;
  border: none;
  background: ${theme.gradient.themeGradient};
  color: ${theme.colors.white};
  font-size: 12px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 8px;
  height: 35px;
  text-align: center;
`;

const backButton = styled.button`
  color: #000000;
  width: 100%;
  border: none;
  font-size: 12px;
  cursor: pointer;
  border-radius: 8px;
  height: 35px;
  text-align: center;
  background: white;
`;

const forgetHeading = styled.p`
  font-family: Roboto;
  font-size: 32px;
  font-weight: 500;
  text-align: left;
  color: #565656;
  margin-bottom: 35px;
  width: 100%;
`;

const forgetpara = styled.p`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  color: #565656cc;
  width: 100%;
  margin-top: -30px;
`;

const imagecontainer = styled.img`
  width: 200px;
  height: 60px;
  margin: 0px 0px 10px 0px;
  object-fit: contain;
`;
const SC = {
  Container,
  LogoLoginImage,
  ForgetForm,
  Form,
  Label,
  TransparentInput,
  Button,
  backButton,
  forgetHeading,
  forgetpara,
  imagecontainer,
};

export default SC;
